export { default } from './BottomSheetBackground';
export type { BottomSheetBackgroundProps } from './types';
